import { PropertySpyListViewContainer } from "features/propertySpy/propertySpyList/ui/containers/PropertySpyListViewContainer/PropertySpyListViewContainer";
import { useAppDispatch } from "../../shared/hooks";
import { useEffect } from "react";
import { setMainBarSettings, setParentUrl } from "../../store/applicationSlice";

export const PropertySpyListPage = (): JSX.Element => {

    const dispatch = useAppDispatch()
    useEffect(() => {
        dispatch(setMainBarSettings({
            back: {
                url: 'property'
            },
            title: 'Property Spies',
            showProfileButton: false
        }))
        dispatch(setParentUrl(`/property`))

        return () => {
            dispatch(setMainBarSettings(undefined))
            dispatch(setParentUrl(undefined))
        }
    });


    return (
        <>
            <PropertySpyListViewContainer></PropertySpyListViewContainer>
        </>
    );
}